export function rgbStringToHex(rgbString: string) {
  const rgb = rgbString.match(/\d+/g)
  return rgb
    ? `#${rgb.map((x) => componentToHex(Number.parseInt(x))).join('')}`
    : ''
}

export function componentToHex(c: number) {
  const hex = c.toString(16)
  return hex.length == 1 ? '0' + hex : hex
}

export function componentsToRgbString(r: number, g: number, b: number) {
  return `rgb(${r}, ${g}, ${b})`
}

export function strToHexColor(stringInput: string): string {
  if (typeof stringInput === 'undefined') {
    return '#000000'
  }

  const stringUniqueHash = [...stringInput].reduce((acc, char) => {
    return acc + char.charCodeAt(0)
  }, 0)

  const palette =
    document.getElementsByClassName('cl-light-theme').length > 0
      ? WHITE_PALETTE
      : DARK_PALETTE

  return palette[stringUniqueHash % palette.length]
}

export const WHITE_PALETTE = [
  '#e887a9',
  '#e25f8d',
  '#de3670',
  '#c71e59',
  '#a11747',
  '#7a1035',
  '#520a23',
  '#d587e8',
  '#c85fe2',
  '#bc36de',
  '#a51ec7',
  '#8517a1',
  '#64107a',
  '#430a52',
  '#9f87e8',
  '#805fe2',
  '#6036de',
  '#491ec7',
  '#3917a1',
  '#2a107a',
  '#1c0a52',
  '#8797e8',
  '#5f75e2',
  '#3652de',
  '#1e3bc7',
  '#172ea1',
  '#10227a',
  '#0a1652',
  '#87bbe8',
  '#5fa5e2',
  '#368fde',
  '#1e78c7',
  '#1760a1',
  '#10487a',
  '#0a3052',
  '#5fd1e2',
  '#36c7de',
  '#1eb1c7',
  '#178ea1',
  '#106c7a',
  '#0a4852',
  '#5fe2bb',
  '#36deab',
  '#1ec794',
  '#17a177',
  '#107a5a',
  '#0a523c',
  '#e2b45f',
  '#dea336',
  '#c78c1e',
  '#a17017',
  '#7a5510',
  '#52390a',
  '#e2935f',
  '#de7936',
  '#c7621e',
  '#a14e17',
  '#7a3a10',
  '#52270a',
]

export const DARK_PALETTE = [
  '#f2b5cb',
  '#ec8eae',
  '#e86392',
  '#e33b75',
  '#d41c5c',
  '#f3ddf8',
  '#e6b5f2',
  '#d98eec',
  '#cd63e8',
  '#c13be3',
  '#ae1cd4',
  '#e3ddf8',
  '#c5b5f2',
  '#a58eec',
  '#8563e8',
  '#643be3',
  '#491cd4',
  '#dde1f8',
  '#b5bff2',
  '#8e9dec',
  '#637ae8',
  '#3b57e3',
  '#1c3bd4',
  '#ddecf8',
  '#b5d6f2',
  '#8ec0ec',
  '#63aae8',
  '#3b94e3',
  '#1c7dd4',
  '#ddf5f8',
  '#b5eaf2',
  '#8edfec',
  '#63d6e8',
  '#3bcce3',
  '#1cbcd4',
  '#ddf8f0',
  '#b5f2e0',
  '#8eecd0',
  '#63e8c0',
  '#3be3b0',
  '#1cd49d',
  '#f8efdd',
  '#f2dcb5',
  '#eccb8e',
  '#e8b963',
  '#e3a73b',
  '#d4941c',
  '#f8e8dd',
  '#f2cdb5',
  '#ecb38e',
  '#e89963',
  '#e37e3b',
]
